import CategoryCard from "../CategoryCard/CategoryCard";

export default function CategoryGrid({ categories, activeCategory }) {
  return (
    <div className="-mx-4 flex gap-4 overflow-x-auto px-4 pb-4 sm:mx-0 sm:grid sm:grid-cols-2 sm:overflow-visible sm:px-0 md:grid-cols-3 lg:grid-cols-5">
      {categories.map((category) => (
        <CategoryCard key={category.id} category={category} active={activeCategory === category.id} />
      ))}
    </div>
  );
}
